export function can(permissions, permission) {
  if (!permissions || permissions.size === 0) return false;

  // 🔑 SUPERADMIN / WILDCARD
  if (permissions.has("*")) return true;

  // Single permission
  if (typeof permission === "string") {
    return permissions.has(permission);
  }

  // Multiple permissions (optional, future-proof)
  if (Array.isArray(permission)) {
    return permission.every((p) => permissions.has(p));
  }

  return false;
}
